<nav class="toolbar navbar navbar-light">
    <div class="form-inline">
        <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>

        <div *ngIf="habilitarComprobarEphytos">
            <button *ngIf="!visibilitySpinnerComprobarEphytos" class="btn btn-outline-success" (click)="onComprobarEstadosEphyto()" title="Comprobar estados de ePhytos enviados">
                <i class="fa fa-clock-o"></i> Comprobar ePhytos
            </button>
            <button *ngIf="visibilitySpinnerComprobarEphytos" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Comprobando estados ePhytos
            </button>
        </div>

        <div *ngIf="habilitarNuevaCopiaCF">
            <button type="button" class="btn btn-outline-success" title="Nueva Copia CF" (click)="nuevaCopiaCF()"><i class="fa fa-file-o"></i> Nueva Copia CF</button>
        </div>

        <div *ngIf="habilitarNuevoNumSeguridad">
            <button type="button" class="btn btn-outline-success" title="Nuevo Nº Seguridad" (click)="nuevoNumSeguridad()"><i class="fa fa-file-o"></i> Nuevo Nº Seguridad</button>
        </div>

    </div>
</nav>

<div class="animated fadeIn container-fluid">
    <div>
        <h5 *ngIf="codigoSolicitud !== null" style="display:inline">Código de Solicitud: {{codigoSolicitud}}</h5>
        <h5 *ngIf="codigoSolicitud !== null" style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" src="{{IdTipoSolicitudEx | IconoTipoSolicitudEx}}" container="body" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" src="{{solicitudEx?.IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" container="body" ngbTooltip="{{tituloEstadoSolicitud}}" />
                <img *ngIf="solicitudEx?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || solicitudEx?.IdSubTipoSolicitudEx === reExpConAtestFito || solicitudEx?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{solicitudEx?.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{solicitudEx?.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" src="{{solicitudEx?.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" container="body" ngbTooltip="{{tituloEstadoCertificadoFitoEx}}" />
                <img *ngIf="solicitudEx?.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{solicitudEx?.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudEx?.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" src="{{ null | IconoEstadoSolicitudEx}}" container="body" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" container="body" ngbTooltip="Clonada"></i>
            </span>
        </h5>
        <h5 *ngIf="codigoSolicitud === null" style="display:inline">Solicitud </h5>
        <h5 *ngIf="codigoSolicitud === null" style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" src="{{IdTipoSolicitudEx | IconoTipoSolicitudEx}}" container="body" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" src="{{solicitudEx?.IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" container="body" ngbTooltip="{{tituloEstadoSolicitud}}" />
                <img *ngIf="solicitudEx?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || solicitudEx?.IdSubTipoSolicitudEx === reExpConAtestFito || solicitudEx?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{solicitudEx?.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{solicitudEx?.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" src="{{solicitudEx?.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" container="body" ngbTooltip="{{tituloEstadoCertificadoFitoEx}}" />
                <img *ngIf="solicitudEx?.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{solicitudEx?.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudEx?.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" src="{{ null | IconoEstadoSolicitudEx}}" container="body" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" container="body" ngbTooltip="Clonada"></i>
            </span>
        </h5>
    </div>

    <ng-container *ngIf="IdSolicitud">
        <app-alertarechazo [id]="IdSolicitud" [esExport]="true"></app-alertarechazo>
    </ng-container>

    <div style="margin-top: 10px;">
        <h5 style="display:inline">
            <span>
                <img class="check-envio" src="{{ visibilityCheckEnvioValue | IconoCheckEnvio}}" />
            </span>
        </h5>
        <h5 style="display:inline">{{mensajeEmision}}</h5>
    </div>

    <div class="row">
        <div class="col-md-12">
            <!--Validaciones propias de la solicitud-->
            <table *ngIf="validacionCollection !== null && validacionCollection?.length > 0" class="table table-responsive table-sm">
                <tbody>
                    <tr *ngFor="let item of validacionCollection">
                        <td class="empty-grid">{{item}}</td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>

    <form [formGroup]="form" autocomplete="off">
        <div class="animated fadeIn container-fluid container-filter" style="padding-top: 0.3rem !important;">
            <div class="row">
                <div class="col-md-12">
                    <!--DATOS DEL ENVÍO DE LA SOLICITUD-->
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDatosEnvio = !isCollapsedDatosEnvio" [attr.aria-expanded]="!isCollapsedDatosEnvio" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos del envío de la solicitud
                                <i *ngIf="isCollapsedDatosEnvio" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDatosEnvio" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedDatosEnvio" [ngbCollapse]="isCollapsedDatosEnvio">
                                <div class="row">
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpFecha">Fecha Envío: </label>
                                        <input formControlName="FechaEnvio" name="FechaEnvio" readonly title="" class="form-control" id="" value="">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpFecha">Número de Solicitud: </label>
                                        <input formControlName="Codigo" name="Codigo" readonly title="" class="form-control" id="" type="text" value="">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <div *ngIf="esPrevia">
                                            <label class="col-form-label" for="inpFecha">Fecha Presentación: </label>
                                            <input formControlName="FechaPresentacion" name="FechaPresentacion" readonly title="" class="form-control" id="" value="">
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <div class="float-right mt-4">
                                            <div class="btn-group">
                                                <button *ngIf="!visibilitySpinnerEnviar" [disabled]="!habilitarEnviar" type="button" class="btn btn-secondary btn-sm" [title]="tituloBoton"
                                                        (click)="enviarSolicitud()">
                                                    <i class="fa fa-envelope-o"></i> {{tituloBoton}}
                                                </button>
                                                <button *ngIf="visibilitySpinnerEnviar" [disabled]="true" type="button" class="btn btn-secondary btn-sm" style="color:white !important">
                                                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                                                    Enviando
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- DATOS CERTIFICADO FITOSANITARIO -->
            <div class="row" *ngIf="visibilidadCFSede">
                <div class="col-md-12">
                    <!--DATOS SEDE -->
                    <div class="card card-accent-success animated fadeIn container-filter">
                        <a class="card-header-a" (click)="isCollapsedDatosCF = !isCollapsedDatosCF" [attr.aria-expanded]="!isCollapsedDatosCF" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos Certificado Fitosanitario
                                <i *ngIf="isCollapsedDatosCF" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDatosCF" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros-cf" id="collapsedDatosCF" [ngbCollapse]="isCollapsedDatosCF">
                                <!--CERTIFICADO FITO EN TRAMITE O FINALIZADO-->
                                <div class="row" *ngIf="solicitudEx?.IdEstadoCertificadoFitoEx !== 1">
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpFecha">Fecha Certificación: </label>
                                        <input formControlName="FechaCertificacion" name="FechaCertificacion" readonly title="" class="form-control" id="" value="">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpFecha">Número de Certificado: </label>
                                        <input formControlName="NumeroCertificado" name="NumeroCertificado" readonly title="" class="form-control" id="" type="text" value="">
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="inpFecha">Estado CF: </label>
                                        <img class="estado-icono-big" src="{{solicitudEx?.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" container="body" ngbTooltip="{{tituloEstadoCertificadoFitoEx}}" />
                                        <input formControlName="EstadoCert" name="EstadoCert" readonly title="" class="form-control" id="" type="text" value="">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpIdiomaCFDescripcion">Idioma:</label>
                                        <input formControlName="IdiomaCFDescripcion" name="IdiomaCFDescripcion" readonly class="form-control" id="inpIdiomaCFDescripcion" type="text">
                                    </div>
                                    <div class="form-group col-md-2" *ngIf="solicitudEx?.TClaveCertCanarias?.Pin !== null">
                                        <label class="col-form-label" for="">PIN: </label>
                                        <input formControlName="Pin" name="Pin" readonly title="" class="form-control" id="" type="text" value="">
                                    </div>

                                    <div class="form-group col-md-2" *ngIf="isInspector && esCanarias">
                                        <label class="col-form-label" for="">Utilizado: </label>
                                        <input formControlName="Utilizado" name="Utilizado" readonly title="" class="form-control" id="" type="text" value="">
                                    </div>
                                    <div class="form-group col-md-2" *ngIf="isInspector && esCanarias">
                                        <label class="col-form-label" for="">Disponible: </label>
                                        <input formControlName="Disponible" name="Disponible" readonly title="" class="form-control" id="" type="text" value="">
                                    </div>

                                    <div class="form-group col-md-4" *ngIf="solicitudEx?.TDatosSedeDocBDEx?.Token !== null">
                                        <label class="col-form-label">CSV Sede Electrónica: </label>
                                        <input formControlName="Token" name="Token" readonly title="" class="form-control" id="" type="text" value="">
                                    </div>

                                    <div *ngIf="isInspector" class="col-md-12 mt-2">
                                        <div class="form-group-0 float-right">
                                            <div class="btn-group">
                                                <button class="btn btn-anular btn-secondary btn-sm" *ngIf="!visibilitySpinnerAnularCF" [disabled]="!habilitarAnularCF" type="button"
                                                        title="Anular sólo el Certificado Fitosanitario" (click)="onAnularCF()">
                                                    Anular sólo CF
                                                </button>
                                                <button *ngIf="visibilitySpinnerAnularCF" [disabled]="true" class="btn btn-anular btn-secondary btn-sm">
                                                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                                                    Anulando CF
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--CERTIFICADO FITO PENDIENTE-->
                                <div class="row" *ngIf="solicitudEx?.IdEstadoCertificadoFitoEx === 1">
                                    <div class="form-group col-md-12">
                                        <label class="col-form-label mt-1"><i class="fa fa-info-circle"></i><b> Certificado Fitosanitario pendiente de emisión y aprobación </b></label>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="">Idioma de la Solicitud:</label>
                                        <ng-select [items]="listIdioma"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdIdiomaCF"
                                                   loadingText="Cargando..."
                                                   [loading]="!listIdioma"
                                                   notFoundText="Idioma no encontrado"
                                                   placeholder="-- Seleccione un Idioma --"
                                                   [ngClass]="displayFieldCssNgSelect('IdIdiomaCF')"
                                                   [readonly]="!habilitarEmitirCF || visibilitySpinnerEmitirCF"
                                                   (change)="onChangeIdiomaCF()"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>
                                    </div>
                                    <div class="col-md-10 mt-3">
                                        <div class="form-group-0 float-right">
                                            <div class="btn-group">
                                                <button *ngIf="!visibilitySpinnerEmitirCF" [disabled]="!habilitarEmitirCF" title="Emitir Certificado Fitosanitario" type="button"
                                                        class="btn btn-secondary btn-sm" (click)="onEmitirCF()">
                                                    <i class="fa fa-leaf"></i> Emitir Certificado Fitosanitario
                                                </button>
                                                <button *ngIf="visibilitySpinnerEmitirCF" [disabled]="true" class="btn btn-secondary btn-sm">
                                                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                                                    Generando Informe
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="visibilidadCFePhyto">
                <div class="col-md-12">
                    <!--DATOS EPHYTO-->
                    <div class="card card-accent-success animated fadeIn container-filter">
                        <a class="card-header-a" (click)="isCollapsedDatosEphyto = !isCollapsedDatosEphyto" [attr.aria-expanded]="!isCollapsedDatosEphyto" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos ePhyto
                                <i *ngIf="isCollapsedDatosEphyto" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDatosEphyto" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros-cf" id="collapsedDatosEphyto" [ngbCollapse]="isCollapsedDatosEphyto">
                                <!--CERTIFICADO FITO PENDIENTE-->
                                <div class="row" *ngIf="solicitudEx?.IdEstadoCertificadoFitoEx === 1">
                                    <div class="form-group col-md-12">
                                        <label class="col-form-label mt-1"><i class="fa fa-info-circle"></i><b> ePhyto pendiente de emisión y aprobación</b></label>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="">Idioma de la Solicitud:</label>
                                        <ng-select [items]="listIdioma"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdIdiomaEphyto"
                                                   loadingText="Cargando..."
                                                   [loading]="!listIdioma"
                                                   notFoundText="Idioma no encontrado"
                                                   placeholder="-- Seleccione un Idioma --"
                                                   [ngClass]="displayFieldCssNgSelect('IdIdiomaEphyto')"
                                                   [readonly]="!habilitarEmitirEPhyto || visibilitySpinnerEmitirEphyto"
                                                   (change)="onChangeIdiomaEphyto()"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>
                                    </div>
                                    <div class="col-md-10 mt-3">
                                        <div class="form-group-0 float-right">
                                            <div class="btn-group">
                                                <button *ngIf="!visibilitySpinnerEmitirEphyto" [disabled]="!habilitarEmitirEPhyto" (click)="sendEphytoOnDemand()" title="Emitir ePhyto"
                                                        type="button" class="btn btn-secondary btn-sm">
                                                    <i class="fa fa-leaf"></i> Emitir ePhyto
                                                </button>
                                                <button *ngIf="visibilitySpinnerEmitirEphyto" [disabled]="true" type="button" class="btn btn-secondary btn-sm">
                                                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                                                    Emitiendo ePhyto
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--CERTIFICADO FITO EN TRAMITE O FINALIZADO-->
                                <div class="row" *ngIf="solicitudEx?.IdEstadoCertificadoFitoEx !== 1">
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpFecha">Fecha: </label>
                                        <input formControlName="FechaCertificacion" name="FechaCertificacion" readonly title="" class="form-control" id="" value="">
                                    </div>

                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpFecha">Número de Certificado: </label>
                                        <input formControlName="NumeroCertificado" name="NumeroCertificado" readonly title="" class="form-control" id="" type="text" value="">
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="inpFecha">Estado ePhyto:</label>
                                        <!-- <img class="estado-icono-big" src="{{solicitudEx.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" container="body" ngbTooltip="{{tituloEstadoCertificadoFitoEx}}" /> -->
                                        <input formControlName="EstadoCert" name="EstadoCert" readonly title="" class="form-control" id="" type="text" value="">
                                    </div>

                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpIdiomaEphytoDescripcion">Idioma:</label>
                                        <input formControlName="IdiomaCFDescripcion" name="IdiomaEphytoDescripcion" readonly class="form-control" id="inpIdiomaEphytoDescripcion" type="text">
                                    </div>

                                    <div *ngIf="estadoEsFinalizadoEphyto" class="col-md-12 mt-2">
                                        <div class="form-group-0 float-right">

                                            <div class="btn-group">
                                                <button *ngIf="!visibilitySpinnerAnularEphyto" [disabled]="!habilitarAnularEPhyto" (click)="cancelEphytoOnDemand()"
                                                        type="button" class="btn btn-anular btn-secondary btn-sm" title="Anular sólo el ePhyto">
                                                    Anular sólo ePhyto
                                                </button>
                                                <button *ngIf="visibilitySpinnerAnularEphyto" [disabled]="true" type="button" class="btn btn-anular btn-secondary btn-sm">
                                                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                                                    Anulando ePhyto
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- DOCUMENTOS DE LA SOLICITUD -->
            <div class="row" *ngIf="visualizarGridDocumentos">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn container-filter">
                        <a class="card-header-a" (click)="isCollapsedDocumentos = !isCollapsedDocumentos" [attr.aria-expanded]="!isCollapsedDocumentos" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i><label class="ps-1" [ngClass]="{ 'required-field' : requerirDocumentos }"> Documentos</label>
                                <i *ngIf="isCollapsedDocumentos" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDocumentos" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros-cf" id="collapsedDocumentos" [ngbCollapse]="isCollapsedDocumentos">
                                <label class="col-form-label">
                                    <i class="fa fa-align-justify"></i> Listado de documentos <!--{{tituloDocumentosEphyto}}-->



                                </label>




                                <p-table #tableSearch autoLayout="true" [value]="documentosEstandar"
                                         [columns]="cols" sortField="Fecha" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(documentosEstandar)"
                                         (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
                                         (onHeaderCheckboxToggle)="selectAllRows($event)" [(selection)]='documentosAttachedEphytoBDChecked'>

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th *ngIf="mostrarDocumentosModoEdicion">
                                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                            </th>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngIf="mostrarDocumentosModoEdicion">
                                                <p-tableCheckbox [value]="rowData"> </p-tableCheckbox>
                                            </td>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">

                                                <span *ngIf="(col.field !== 'Link' && col.field !== 'Fecha')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <span *ngIf="col.field==='Fecha'">
                                                    {{rowData[col.field] | date:'dd/MM/yyyy'}}
                                                </span>

                                                <div *ngIf="col.field==='Link'">

                                                    <button (click)="onDownload(rowData)" type="button" title="Descargar Documento" class="btn btn-sm btn-danger">
                                                        <span class="fa fa-download"></span>
                                                    </button>

                                                    <span class="float-right" *ngIf="isTracesInfoVisible(rowData, 'Autogenerado')">
                                                        <img class="estado-icono" src="{{ (rowData['Autogenerado'] | IconoDocumentoExTraces:['Autogenerado', rowData['EsEphyto']])[0]}}"
                                                             container="body" ngbTooltip="{{ (rowData['Autogenerado'] | IconoDocumentoExTraces:['Autogenerado', rowData['EsEphyto']])[1]}}" />
                                                    </span>

                                                    <span class="float-right" *ngIf="isTracesInfoVisible(rowData, 'AttachedEphyto')">
                                                        <img class="estado-icono" src="{{ (rowData['AttachedEphyto'] | IconoDocumentoExTraces:['AttachedEphyto'])[0]}}"
                                                             container="body" ngbTooltip="{{ (rowData['AttachedEphyto'] | IconoDocumentoExTraces:['AttachedEphyto'])[1]}}" />
                                                    </span>

                                                    <span class="float-right" *ngIf="isTracesInfoVisible(rowData, 'Autogenerado')">
                                                        <!-- @author jlht Las copias de CF tienen iconos de estado diferentes al CF original. Distinguir qué pipe pintará el icono en función de si es o no copia el documento -->
                                                        <img class="estado-icono" *ngIf="rowData['IdCopia'] === null" src="{{ rowData['IdEstadoCertificadoFitoEx'] | IconoEstadoCertificadoFitoEx}}"
                                                             ngbTooltip="{{rowData['IdEstadoCertificadoFitoExDescripcion']}}" />
                                                        <img class="estado-icono" *ngIf="rowData['IdCopia'] > 0" src="{{ rowData['IdEstadoCertificadoFitoEx'] | IconoCopiaCertificadoEx}}"
                                                             ngbTooltip="{{rowData['IdEstadoCertificadoFitoExDescripcion']}}" />
                                                    </span>

                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                                <div *ngIf="numeroDocumentos === 0" class="empty-grid">
                                    No hay documentos asociados a la solicitud
                                </div>
                                <!-- FIN DOCUMENTOS PARA EL EPHYTO -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="solicitudEx?.TSeguridadCertificadoFitoCollection?.length > 0">
                <app-numerosseguridad-list></app-numerosseguridad-list>
            </div>

            <div *ngIf="solicitudEx?.TCopiaCertificadoExCollection?.length > 0">
                <app-copiacfex-list [copiasSolicitud]="solicitudEx?.TCopiaCertificadoExCollection" [estadoSolicitud]="solicitudEx?.IdEstadoSolicitudEx"
                                    [estadoCertificadoFitoEx]="solicitudEx?.IdEstadoCertificadoFitoEx" [idSolicitud]="solicitudEx?.Id"
                                    (updateParentForm)="ngOnInit()">
                </app-copiacfex-list>
            </div>
        </div>

    </form>

</div>
